import {
  APP_LOADING,
  APP_MESSAGE,
  SET_CONTRAST,
  FONT_SIZE,
} from "../constants";

export const appLoading = (status) => {
  return { type: APP_LOADING, payload: status };
};

//take attention that appMessage removes also appLoading()
export const appMessage = (message) => {
  return { type: APP_MESSAGE, payload: message };
};

export const updateAppContrast = () => ({ type: SET_CONTRAST });

export const updateAppFontSize = () => ({ type: FONT_SIZE });



// WEBPACK FOOTER //
// ./src/actions/appActions.js